import { Component, OnInit } from "@angular/core";
import dayjs from "dayjs";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: false,
})
export class FooterComponent {
  footerYear: number = dayjs().year();
}
